// -------------------------------------------------------------------------
// MARK: Default Data for Recurring Summary page
// Needed to set default data for the receipts page to be able to process
// information for display in CMS.
// -------------------------------------------------------------------------
export const DEFAULT_RECEIPT_ID = "12345";

const recurringSummaryDefaultValues = {
    transaction: {
        address: "123 Testing Road",
        amount: "50",
        anonymous: "n",
        assocInfo: "",
        bill_address: "123 Testing Road",
        bill_city: "Testing City",
        bill_country: "US",
        bill_state: "FL",
        bill_zip: "33809-5034",
        ccLastFour: 1111,
        ccName: "John Doe",
        ccType: "VS",
        city: "Testing City",
        company: "",
        country: "US",
        creatingTransactionFor: 0, // no idea what this means
        date: "2021-04-26",
        demo: "y",
        donations: [
            {
                amount: 50,
                amountName: "",
                id: 123,
                restriction: "",
                subRestriction: "",
            },
        ],
        email: "john_doe@test.com",
        fname: "John",
        fields: [],
        form: 10417,
        id: DEFAULT_RECEIPT_ID,
        lname: "Doe",
        optin: "",
        org: 18419,
        originalTransaction: {
            total: 50,
            donationAmount: 50,
            giftAssistAmount: 0,
        },
        phone: 1234567890,
        receiptId: DEFAULT_RECEIPT_ID,
        recurring: {
            CCID: "0",
            address: "",
            amount: "52.5",
            amtPledged: "52.5",
            anonymous: "n",
            assocInfo: "",
            authId: "",
            ccName: "",
            ccType: "",
            cc_key: null,
            city: "",
            country: "",
            creatingTransaction: "26402686",
            date: "2025-02-13 15:58:00",
            email: null,
            exp_key: null,
            expiry: null,
            finalBill: "0000-00-00",
            firstBill: "2025-02-13",
            fname: "",
            form: "12664",
            frequency: "1",
            frequencyUnit: "month",
            frequency_description: "Monthly",
            id: "1414433",
            installmentReceipt: "1",
            ipAdd: "72.188.0.157",
            lastFour: "0",
            lname: "",
            nextBill: "2025-11-13",
            notificationSent: "0",
            org: "21213",
            origAmt: "0.00",
            origNetId: "",
            paymentMethod: "18172",
            paymentNotificationSent: "0",
            pledge: "0",
            prevTrans: "26405825",
            previousBill: "2025-04-01",
            receiptId: "p7p43wcx2hkx9tk2g9qbrg7dj3r49qt3",
            receiptSent: "0",
            remainingBills: "0",
            retryCount: "0",
            retryDate: "0000-00-00",
            salutation: "",
            state: "",
            status: "active",
            stopReason: "",
            testing: "no",
            zip: "",
        },
        salutation: "",
        source: "don_form",
        state: "Florida",
        status: "A",
        tm_stamp: "2021-04-26 10:10:15",
        zip: "33809-5304",
    },
    total: 50,
};

const recurringSummaryHistoryDefaultValues = {
    historicalTotalCount: 2,
    historicalTotalImpact: 100,
    transactionHistory: [
        {
            address: "207 N Bartow",
            amount: "50.00",
            anonymous: "n",
            assocInfo: "",
            batch_id: null,
            bill_address: "123 Testing Road",
            bill_city: "Testing City",
            bill_country: "US",
            bill_state: "FL",
            bill_zip: "33809-5034",
            billed: "N",
            ccLastFour: "1111",
            ccName: "John Doe",
            ccType: "VS",
            channel: "0",
            city: "Testing City",
            company: "",
            companyDonation: "0",
            country: "US",
            creatingTransactionFor: "16659",
            date: "2024-01-10",
            demo: "y",
            email: "john_doe@test.com",
            employer: "",
            fname: "John",
            form: "12063",
            fraudPattern: "0",
            gw_error: "Transaction Voided",
            gw_trans_id: "",
            hasSubmittedConfirmationFieldsForm: "0",
            hidden: "n",
            id: "23456",
            ipAdd: "172.25.0.1",
            isExpressCheckout: "0",
            is_fraud: "0",
            lname: "Doe",
            memo: "",
            merchantAccount: "69605",
            movedFrom: null,
            movedTo: null,
            optIn: "n",
            org: "12345",
            part_fee: "0.00",
            part_info: "",
            phone: "",
            qgiv_fee: "0.00",
            receiptId: "xyz123",
            recurring: "16659",
            refund_amount: "0.00",
            refundedAt: "0000-00-00 00:00:00",
            reseller: "3",
            salutation: "",
            server: "54cd18424d",
            settlement_date: "2024-01-12",
            source: "don_form",
            source_id: "0",
            state: "Florida",
            statement: "0",
            status: "A",
            suffix: "",
            tm_stamp: "2024-01-11 14:50:26",
            userAgent: "",
            workEmail: "",
            zip: "12345",
        },
        {
            address: "207 N Bartow",
            amount: "50.00",
            anonymous: "n",
            assocInfo: "",
            batch_id: null,
            bill_address: "123 Testing Road",
            bill_city: "Testing City",
            bill_country: "US",
            bill_state: "FL",
            bill_zip: "33809-5034",
            billed: "N",
            ccLastFour: "1111",
            ccName: "Jane Doe",
            ccType: "VS",
            channel: "0",
            city: "Testing City",
            company: "",
            companyDonation: "0",
            country: "US",
            creatingTransactionFor: "16659",
            date: "2024-01-10",
            demo: "y",
            email: "jane_doe@test.com",
            employer: "",
            fname: "Jane",
            form: "12063",
            fraudPattern: "0",
            gw_error: "Transaction Voided",
            gw_trans_id: "",
            hasSubmittedConfirmationFieldsForm: "0",
            hidden: "n",
            id: "23457",
            ipAdd: "172.25.0.1",
            isExpressCheckout: "0",
            is_fraud: "0",
            lname: "Doe",
            memo: "",
            merchantAccount: "69605",
            movedFrom: null,
            movedTo: null,
            optIn: "n",
            org: "12345",
            part_fee: "0.00",
            part_info: "",
            phone: "",
            qgiv_fee: "0.00",
            receiptId: "abc789",
            recurring: "16659",
            refund_amount: "0.00",
            refundedAt: "0000-00-00 00:00:00",
            reseller: "3",
            salutation: "",
            server: "54cd18424d",
            settlement_date: "2024-01-12",
            source: "don_form",
            source_id: "0",
            state: "Florida",
            statement: "0",
            status: "A",
            suffix: "",
            tm_stamp: "2024-01-10 14:50:26",
            userAgent: "",
            workEmail: "",
            zip: "12345",
        },
    ],
};

export { recurringSummaryDefaultValues, recurringSummaryHistoryDefaultValues };
